<template>
  <div class="op-dropdown-select" v-loading="loading">
    <el-dropdown
      ref="opDropdownSelect"
      size="mini"
      trigger="click"
      type="primary"
    >
      <el-input
        :clearable="isShow"
        :readonly="true"
        :disabled="disabled"
        v-if="type === 'input'"
        @click.native="handlerClick"
        v-model="nameValue"
        :placeholder="placeholder"
      >
        <template slot="append" v-if="!disabled">
          <el-button @click.stop="handleClear">清除</el-button>
        </template>
      </el-input>
      <el-button v-else-if="type === 'button'" @click.native="handlerClick">{{
        buttonText
      }}</el-button>
      <el-dropdown-menu
        :disabled="disabled"
        class="op-dropdown-menu"
        :class="{ active: !isShow }"
        slot="dropdown"
      >
        <el-popover
          class="op-dropdown-tips"
          placement="right-start"
          title="组织类型图鉴"
          width="100"
          trigger="hover"
        >
          <div v-for="item in tipsList" :key="item.type">
            <i
              class="op-dropdown-image-icon"
              v-if="iconType === 'image'"
              :style="handlerIcon(item.type)"
            ></i>
            <i
              v-else-if="iconType === 'class'"
              class="iconfont op-dropdown-image-icon"
              :class="handlerIcon(item.type)"
            ></i>
            <span>:&nbsp;&nbsp;{{ item.name }}</span>
          </div>
          <i class="el-icon-warning-outline" slot="reference"></i>
        </el-popover>
        <div class="op-tree-serach" style="margin-bottom: 10px">
          <el-input
            ref="focus"
            placeholder="输入关键字进行过滤"
            v-model="filterText"
            @input="filterOnInput"
            autofocus
          ></el-input>
        </div>
        <el-tree
          v-show="isShow"
          ref="opDropdownTree"
          :data="treeDataList"
          :highlight-current="!multiple"
          :show-checkbox="multiple"
          :check-strictly="true"
          :expand-on-click-node="false"
          node-key="id"
          :default-checked-keys="defaultCheckedKeys"
          :default-expanded-keys="defaultCheckedKeys"
          @node-click="handleNodeClick"
          @check-change="handleCheckChange"
          :filter-node-method="filterNode"
          :props="treeProps"
        >
          <span slot-scope="{ node, data }">
            <i
              class="op-dropdown-image-icon"
              v-if="iconType === 'image'"
              :style="handlerIcon(data.type)"
            ></i>
            <i
              v-else-if="iconType === 'class'"
              class="iconfont op-dropdown-image-icon"
              :class="handlerIcon(data.type)"
            ></i>
            <span>{{ node.label }}{{ getLeaveName(data.status) }}</span>
          </span>
        </el-tree>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import Vue from "vue";
import Card from "@/components/Card";
import HandlerData from "@/util/handler-data.js";
import { api } from "@/api/index";
import { reqGetCurrentUser, getDict } from "@oppein/op-utils";
export default {
  name: "OrganizationSelect",
  components: {
    Card,
  },
  props: {
    value: {
      type: [String, Array],
      default: "",
    },
    type: {
      type: String,
      default: "input",
    },
    buttonText: {
      type: String,
      default: "选择",
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    white: {
      type: String,
      default: "",
    },
    orgId: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    treeProps: {
      type: Object,
      default: () => {
        return {
          value: "id",
          label: "name",
          children: "children",
        };
      },
    },
    treeData: {
      type: Array,
      default: () => [],
    },
    iconType: {
      type: String,
      default: "image",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    updateData: {
      type: Boolean,
      default: false,
    },
    isLeave: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      isShow: false,
      treeDataList: [],
      defaultCheckedKeys: [],
      nameValue: "",
      filterText: "",
      iconConfig: {
        image: {
          agent: require("@/assets/images/ucenter/market.png"),
          shop: require("@/assets/images/ucenter/store.png"),
          department: require("@/assets/images/ucenter/department.png"),
          team: require("@/assets/images/ucenter/team.png"),
          oppein: require("@/assets/images/ucenter/oppein.png"),
          member: require("@/assets/images/ucenter/member.png"),
          default: require("@/assets/images/ucenter/position.png"),
        },
        class: {
          agent: "icon-shangchang",
          shop: "icon-xianxiamendian",
          department: "icon-huaban",
          team: "icon-zuzhijiagou",
          member: "icon-kehu1",
          default: "icon-gerenyonghutouxiang2",
        },
      },
      tipsList: [
        { type: "agent", name: "商场" },
        { type: "shop", name: "门店" },
        { type: "department", name: "部门" },
        { type: "team", name: "小组" },
        { type: "member", name: "人员" },
        { type: "position", name: "岗位" },
      ],
    };
  },
  computed: {
    // 修复computed属性的写法
    sidebar() {
      return this.$store.state.orderForm.sidebar;
    },
    userInfo() {
      return this.$store.state.authModule.user;
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler() {
        this.handlerName(this.value);
      },
    },
  },
  mounted() {
    // 如果config.treeData传进来的值为空或者没传 默认获取商场组织结构数据
    if (this.treeData && this.treeData.length) {
      this.treeDataList = JSON.parse(JSON.stringify(this.treeData));
    } else {
      this.getDataList();
    }
    this.treeProps.disabled = this.setDisabled;
  },
  methods: {
    /// 当开启多选的时候 不在白名单中的值禁用
    setDisabled(data, node) {
      return !(this.white.indexOf(data.type) > -1);
    },

    // 获取商场组织架构
    getDataList() {
      console.log("userInfo---", this.userInfo);
      if (
        (this.userInfo.marketId === "1" ||
          this.userInfo.departmentId === "1") &&
        !this.orgId
      )
        return; // oppein.com的用户不加载组织架构树
      let organizationalStructureList =
        JSON.parse(sessionStorage.getItem("organizationalStructureList")) || [];
      if (organizationalStructureList.length > 0 && !this.updateData) {
        this.treeDataList = this.handlerTreeData(organizationalStructureList);
        // this.handlerName(this.value)
        this.handlerDefaultChecked();
      } else {
        // this.loading = true
        api.uc
          .getOrganizationalStructureList({
            orgType: "AGENT",
            orgId:
              this.userInfo.departmentId === "1"
                ? this.orgId
                : this.userInfo.departmentId,
          })
          .then((res) => {
            let list = res.data.departmentList.concat(
              res.data.positionList,
              res.data.userList,
            );
            sessionStorage.setItem(
              "organizationalStructureList",
              JSON.stringify(list),
            );
            this.treeDataList = this.handlerTreeData(list);
            this.handlerName(this.value);
            this.handlerDefaultChecked();
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    // 将扁平化数据处理成树结构
    handlerTreeData(data = []) {
      data = Array.isArray(data) ? data : [];
      if (this.white === "shop") {
        data = data.filter((item) => {
          if (item.type === "shop" || item.type === "department") return true;
          return false;
        });
      }
      let handlerData = new HandlerData();
      data = data.reduce((accumulator, list) => {
        if (list.account) list.type = "member";
        if (this.isLeave || +list.status !== 5) {
          accumulator.push({
            ...list,
          });
        }
        return accumulator;
      }, []);
      let result = handlerData.toTree(data, "id", "superiorId", true);
      return result;
    },

    // 显示已离职
    getLeaveName(status) {
      return +status === 5 ? "(离职)" : "";
    },

    // 树结构过滤监听
    filterOnInput() {
      this.treeDataList.length &&
        this.$refs.opDropdownTree.filter(this.filterText);
    },

    // 处理过滤结果
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },

    // 处理默认选中数据
    handlerDefaultChecked() {
      Array.isArray(this.value) &&
        (this.defaultCheckedKeys = JSON.parse(JSON.stringify(this.value)));
    },

    // 根据icon类型、数据类型获取对应icon
    handlerIcon(type) {
      let key = this.iconConfig[this.iconType][type];
      key = key || this.iconConfig[this.iconType]["default"];
      if (this.iconType === "image") {
        return `background-image:url(${key});`;
      } else if (this.iconType === "class") {
        return key;
      }
    },

    // 点击input的回调
    handlerClick(event) {
      this.filterText = "";
      if (this.disabled) return; // false;
      this.showSelect();
      this.getDataList();
      setTimeout(() => {
        this.$refs.focus.focus();
      }, 100);
      this.$emit("onClick");
    },

    // 点击清空回调
    handleClear() {
      this.$refs.opDropdownSelect.visible = false;
      if (this.multiple) {
        this.$emit("onCheckChange", []);
      } else {
        this.nameValue = "";
        this.$emit("onNodeClick", {});
      }
      this.handlerName(this.value);
      this.isShow = true;
      return false;
    },

    // 节点被点击的回调 单选有效
    handleNodeClick(data) {
      if (this.multiple) {
        this.$refs.opDropdownTree.setChecked(data, !this.handelIsCheck(data));
        return;
      }
      this.$refs.opDropdownSelect.visible = false;
      if (!this.whiteChange(data) || this.multiple) {
        return false;
      }
      this.nameValue = data.name;
      this.$emit("onNodeClick", data);
    },

    // 节点被勾选、取消勾选的回调 多选有效
    handleCheckChange(data = []) {
      if (!this.multiple) {
        return;
      }
      let nodes = this.$refs.opDropdownTree.getCheckedNodes();
      let idArr = nodes.reduce((accumulator, list) => {
        accumulator.push(list.id);
        return accumulator;
      }, []);
      this.handlerName(idArr);
      this.$emit("onCheckChange", nodes);
    },

    // 检测是否选中
    handelIsCheck(data) {
      let nodes = this.$refs.opDropdownTree.getCheckedNodes();
      return nodes.some((item) => {
        return item.id === data.id;
      });
    },

    // 显示下拉菜单
    showSelect() {
      // this.$refs.select.blur()
      this.isShow = true;
    },

    // 隐藏下拉菜单
    hideSelect() {
      this.isShow = false;
    },

    // 白名单检测，针对单选有效
    whiteChange(data) {
      if (!this.white || this.multiple) {
        return true;
      } else {
        if (this.white === "position") {
          let types = ["agent", "shop", "department", "team", "member"];
          if (types.includes(data.type)) {
            this.$message.warning("请选择岗位");
          } else {
            return true;
          }
        } else if (this.white.indexOf(data.type) < 0) {
          let messageType = {
            agent: "商场",
            shop: "门店",
            department: "部门",
            team: "小组",
            position: "岗位",
            member: "人员",
          };
          this.$message.warning("请选择" + messageType[this.white]);
        } else {
          return true;
        }
      }
    },

    // 处理名称
    handlerName(value) {
      if (!value) {
        // this.nameValue = "";
        return false;
      }
      let organizationalStructureList =
        JSON.parse(sessionStorage.getItem("organizationalStructureList")) || [];
      let nameArr = organizationalStructureList.reduce((accumulator, list) => {
        if (value.indexOf(list.id) > -1) {
          accumulator.push(list.name);
        }
        return accumulator;
      }, []);
      this.nameValue = nameArr.join(",");
    },
  },
};
</script>

<style scoped lang="scss">
.op-dropdown-menu {
  max-height: 350px;
  overflow-y: scroll;
  padding: 10px 30px 10px 10px;
  font-size: 14px;
  &.active {
    display: none;
  }
}
.op-dropdown-tips {
  position: absolute;
  right: 5px;
  top: 12px;
  color: #fc9153;
  font-size: 20px;
}
.op-dropdown-image-icon {
  display: inline-block;
  color: #fc9153;
  width: 20px;
  height: 20px;
  line-height: 20px;
  font-size: 16px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 85%;
  vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// index.vue?963fd3a4